import { render } from "./DashboardBoxShow.vue?vue&type=template&id=ab2fae4e&scoped=true"
import script from "./DashboardBoxShow.vue?vue&type=script&lang=js"
export * from "./DashboardBoxShow.vue?vue&type=script&lang=js"

import "./DashboardBoxShow.vue?vue&type=style&index=0&id=ab2fae4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2fae4e"]])

export default __exports__